// components imports
import '../auction_registration/additional_details/what_is_your_occupation_section.js';
import '../../../sass/screens/invited_via_email/index.scss';

import {
  initializeForm,
  appendAndGetUniqueFormElement,
} from '../../utils/form';
import {
  UPLOAD_FILE_AS_UNREGISTERED_USER,
  REMOVE_FILE_AS_UNREGISTERED_USER,
  FILE_UPLOAD_ELEMENTS_IDS,
} from '../../consts';
import { initializeInstantFileUploaders } from '../../components/file_uploader';
import {
  validateEmail,
  validateNotEmpty,
  validatePasswordComplexity,
  validateWhatIsYourOccupation,
} from '../../utils/validators';

import {
  defaultDatepickerOptions,
  initializeDatepicker,
} from '../../components/datepicker';

const CONTAINER = '#invited-via-email-documents';

const CSRF_TOKEN_ELEMENT = '#invited-via-email-documents-csrf-token';

const url_array = location.href.split('/');
const token = url_array[url_array.length - 1];

$(() => {
  const invitedViaEmailCreateAccountSelector = $(
    '#invited-via-email-create-account-form'
  );
  const whatIsYourOccupation = $('.what-is-your-occupation');
  const occupationIsSelfValidated = whatIsYourOccupation.hasClass(
    'self-validated'
  );
  let occupationIsRequired;
  try {
    occupationIsRequired = whatIsYourOccupation[0].hasAttribute('required');
  } catch (TypeError) {
    occupationIsRequired = false;
  }

  const invitedViaEmailDetailsForm = $('#invited-via-email-details-form');
  initializeForm(invitedViaEmailDetailsForm, {
    preventDefault: false,
    dateInputs: [
      {
        selector: "input[name='date-of-birth']",
      },
    ],
    skipInputs: [
      'submit',
      'csrfmiddlewaretoken',
      'button',
      'form_type',
      'country_select_filter',
    ],
    validate: (values) => {
      const errors = {
        ...validateNotEmpty(values, [
          'address',
          'postal',
          'last-name',
          'first-name',
          'phone',
        ]),
        ...(!!(occupationIsRequired && occupationIsSelfValidated) &&
          validateWhatIsYourOccupation(values)),
      };
      const hasErrors = !$.isEmptyObject(errors);
      $('#invited-via-email-details-form-button').attr('disabled', hasErrors);

      return errors;
    },
  });

  initializeForm(invitedViaEmailCreateAccountSelector, {
    preventDefault: false,
    validate: (values) => {
      const errors = {
        ...validatePasswordComplexity(values, 'password'),
        ...validateNotEmpty(values, ['password']),
      };

      const hasErrors = !$.isEmptyObject(errors);
      $('#invited-via-email-create-account-form-button').attr(
        'disabled',
        hasErrors
      );

      return errors;
    },
    passwordHintField: 'password',
  });
  initializeInstantFileUploaders({
    elementsIds: FILE_UPLOAD_ELEMENTS_IDS,
    container: CONTAINER,
    csrfTokenElement: CSRF_TOKEN_ELEMENT,
    uploadEndpoint: UPLOAD_FILE_AS_UNREGISTERED_USER + '/' + token,
    removeEndpoint: REMOVE_FILE_AS_UNREGISTERED_USER + '/' + token,
    isMakeAnOfferFile: false,
  });

  const photoDateField = $('[name="photo_date"]').get(0);
  if (photoDateField) {
    initializeDatepicker(photoDateField, {
      ...defaultDatepickerOptions,
      maxDate: photoDateField.getAttribute('max-date') || null,
      minDate: photoDateField.getAttribute('min-date') || null,
    });
  }

  const addressDateField = $('[name="address_date"]').get(0);
  if (addressDateField) {
    initializeDatepicker(addressDateField, {
      ...defaultDatepickerOptions,
      maxDate: addressDateField.getAttribute('max-date') || null,
      minDate: addressDateField.getAttribute('min-date') || null,
    });
  }
});
